export default "__VITE_ASSET__8f250402__"